import React from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import { supabase } from '../App';

const navLinkClassName = ({ isActive }) => `nav-link${isActive ? ' active' : ''}`;

const Header = ({ currentUser }) => {
  const handleLogout = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      // The auth state change listener in App.js will handle updating currentUser
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="app-title">Deal2Meal</h1>
        <nav className="navigation">
          <NavLink to="/deals" className={navLinkClassName}>Deals</NavLink>
          <NavLink to="/recipes" className={navLinkClassName}>Recipes</NavLink>
          <NavLink to="/favorites" className={navLinkClassName}>Favorites</NavLink>
          <NavLink to="/shopping-list" className={navLinkClassName}>Shopping List</NavLink>
          {currentUser ? (
            <>
              <span className="user-info">Hello, {currentUser.email}</span>
              <button onClick={handleLogout} className="btn btn-secondary logout-button">Logout</button>
            </>
          ) : (
            <NavLink to="/login" className={navLinkClassName}>Login</NavLink>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;